<template>
  <div class="howtouse">
    <h1 class="title">
      How to Use
    </h1>
    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
};
</script>
<style scoped>
div.howtouse {
  padding-right: 2em;
  line-height: 1.7;
}
</style>
